import React from 'react';
import { CellRendererProps } from '../../DataTable.types';
import Tooltip from '../../../Tooltip/Tooltip';
import { isEmpty, truncateByCharacters } from '../../../../../utils/utils';

export const TextCellRenderer: React.FC<CellRendererProps> = ({ value, row }) => {
    if (isEmpty(value)) {
        return <span> - </span>;
    }
    if (Array.isArray(value)) {
        if (value.length > 1) {
            return (
                <div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                    {truncateByCharacters(value[0], 40)},
                    <Tooltip content={value.join(', ')} direction="bottom">
                        <span style={{ color: 'var(--primary-text-colour)', fontSize: '12px' }}> +{value.length - 1} more</span>
                    </Tooltip>
                </div>
            );
        }
    }
    return <span style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>{truncateByCharacters(String(value), 40)}</span>;
};
